<template>
  <div class="relative my-5">
    <div class="flex cursor-pointer" v-on:click="isOpen = !isOpen">
      <h3 class="text-[18px] font-bold">{{title}}</h3>
      <div class="absolute right-1 top-1">
        <IconChevron :isOpen="isOpen"/></div>
    </div>
    <div class="whitespace-pre-wrap" :class="isOpen ? 'block' : 'hidden'">{{content}}</div>
  </div>
</template>

<script>
import IconChevron from '@/components/Host/IconChevron.vue'
export default {
  name: 'ExpandText',
  props: {
    title: {
      type: String,
      default: 'Title'
    },
    content: {
      type: String,
      default: 'Content'
    }
  },
  data: () => {
    return {
      isOpen: false
    }
  },
  methods: {},
  components: { IconChevron }
}
</script>
